export default __webpack_public_path__ + "images/35a8ea41d100e72322a415cd2db172e4.webp";